export const ReceiveRouting = [
  {
    path: "/purchase/receive/list",
    name: "purchase-receive-list",
    meta: { title: "订单入库申请" },
    notice: { type: "purchase_receive_order_examine", hasNotice: false },
    component: () =>
      import(/* webpackChunkName: "purchase-receive" */ "@/views/purchase/receive/list/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/receive/create",
    name: "purchase-receive-create",
    meta: { title: "新增订单入库申请", comName: "PurchaseReceiveFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-receive" */ "@/views/purchase/receive/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/receive/edit/:id",
    name: "purchase-receive-edit",
    meta: { title: "编辑订单入库申请", comName: "PurchaseReceiveFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-receive" */ "@/views/purchase/receive/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/receive/detail/:id",
    name: "purchase-receive-detail",
    meta: { title: "订单入库申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-receive" */ "@/views/purchase/receive/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/receive/flowPrint/:id",
    name: "purchase-receive-flowPrint-detail",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-receive" */ "@/views/purchase/receive/flow-print/index.vue"
      ),
  },
];
